import React, { FC } from 'react';
import Svg from 'svg-inline-react';
import { Link } from 'react-router-dom';
import { NEW_FUNNEL_ROUTE } from '@src/Routes/links';
import { trackViewCreateTargeting } from '@src/metrics';
import { MetricContext, MetricEventSource } from '@src/metrics/metrics.enum';
import { OpeningStateEnum } from '@src/graphql/generated';
import OpeningsEmptyStateSvg from '@src/svgs/openings-empty-state.svg';
import { TabKeyType } from '@src/containers/Source/OpeningStates/interfaces/tab.interface';
import { OpeningsEmptyStateProps } from './props';
import './styles.scss';

export const OpeningsEmptyState: FC<OpeningsEmptyStateProps> = ({ selectedFilterKey }) => {
  const getEmptyStateActiveLabel = (selectedFilterKey?: TabKeyType) => {
    switch (selectedFilterKey) {
      case OpeningStateEnum.ACTIVE:
        return 'You don’t have any active positions yet.';
      case OpeningStateEnum.INACTIVE:
        return 'No inactive positions yet.';
      case OpeningStateEnum.DRAFT:
        return 'No draft positions yet.';
      default:
        return 'You don’t have any positions yet.';
    }
  };

  return (
    <div className="source-openings-empty-state">
      <div className="source-openings-empty-state__inner">
        <Svg className="source-openings-empty-state__image" src={OpeningsEmptyStateSvg} />

        <div className="source-openings-empty-state__info">
          <p className="source-openings-empty-state__title">{getEmptyStateActiveLabel(selectedFilterKey)}</p>

          {selectedFilterKey === OpeningStateEnum.ACTIVE && (
            <Link
              className="source-openings-empty-state__link"
              onClick={() =>
                trackViewCreateTargeting({
                  'Event Source': MetricEventSource.OPENINGS_LIST_EMPTY_STATE_BUTTON,
                  'Previous Context': MetricContext.OPENINGS_LIST,
                })
              }
              to={NEW_FUNNEL_ROUTE}
            >
              Create a position
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};
